<template>
  <main :id="$style.main">
    <main-title
      :class="$style.title"
      :main_title="'夢郵便応募詳細'"
      :sub_title="''"
      :color="'#192C58'"
      :align="'center'"
    ></main-title>
    <figure :id="$style.pannel_img"></figure>
    <div :id="$style.pannel_caption">
      夢郵便ハガキを投函されました皆様に抽選で、松井秀喜直筆のサイン色紙を10名様(年間)に
      <br />プレゼントさせて戴いています。尚、当選の発表は(毎年2月下旬)発送をもって代えさせて戴きます。
    </div>

    <div :id="$style.howto_post">
      <div :id="$style.subtitle">
        <span></span>
        <p>夢郵便の投函方法について</p>
      </div>
      <div :id="$style.howto_post_caption">
        投函方法は以下の図の通りです。当館館内ショップにて専用ハガキと切手をご購入の上、
        <br />あなたの夢を書きポストに投函してください。
      </div>
      <figure :id="$style.howto_img"></figure>
      <div :id="$style.howto_post_explain">
        <ol>
          <li>皆さまから投函されたはがきは、受付番号を付し、松井選手からのメッセージ入りシールを貼り、 ご自宅に配送致します。</li>
          <li>
            皆さまから投函された夢は、当館ホームページを通して 松井選手に読んでもらいます。 また、掲載は希望の方のみとし、
            〔受付番号、性別、年齢、夢〕を掲載させていただきます。
          </li>
          <li>お客様の個人情報は厳重に管理し本企画のみ使用させていただきます。</li>
        </ol>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";

export default Vue.extend({
  name: "DreamPostDtailView",

  components: {
    MainTitle
  }
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  $pannel_img_width: 300px;
  $pannel_img_height: 200px;
  $howto_img_width: 300px;
  $howto_img_height: 100px;
  $font_size: 14px;
  #main {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    background-color: #e0f5e7;
    min-height: 100vh;
    #pannel_img {
      background-image: url("../../assets/img/dream_post.jpg");
      background-size: $pannel_img_width $pannel_img_height;
      background-repeat: no-repeat;
      margin: 30px 0px;
      width: $pannel_img_width;
      height: $pannel_img_height;
    }
    #pannel_caption {
      color: #403f3f;
      margin: 0px 20px;
      font-size: $font_size;
      text-align: center;
    }
    #howto_post {
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-wrap: wrap;
      #subtitle {
        width: 100%;
        color: #020202;
        font-size: 16px;
        margin-top: 70px;
        position: relative;
        padding-left: 20px;
        span {
          width: 20px;
          height: 100%;
          position: absolute;
          background-color: #000462;
          border-radius: 2px;
        }
        p {
          margin: 0;
          width: 230px;
          text-align: center;
          border-bottom: 1px solid #040062;
        }
      }
      #howto_post_caption {
        font-size: $font_size;
        color: #403f3f;
        margin: 30px 20px;
      }
      #howto_img {
        background-image: url("../../assets/img/howto_dream_post.jpg");
        background-size: $howto_img_width $howto_img_height;
        background-repeat: no-repeat;
        margin: 0;
        margin-top: 10px;
        width: $howto_img_width;
        height: $howto_img_height;
      }
      #howto_post_explain {
        color: #2f2f2f;
        margin: 30px 20px;
        font-size: $font_size;
        ol {
          padding-left: 20px;
          li {
            margin: 7px 0px;
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  $pannel_img_width: 500px;
  $pannel_img_height: 361px;
  $howto_img_width: 600px;
  $howto_img_height: 171px;
  #main {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    background-color: #e0f5e7;
    #pannel_img {
      background-image: url("../../assets/img/dream_post.jpg");
      background-size: $pannel_img_width $pannel_img_height;
      background-repeat: no-repeat;
      margin: 30px 0px;
      width: $pannel_img_width;
      height: $pannel_img_height;
    }
    #pannel_caption {
      color: #403f3f;
      margin: 0px;
      text-align: center;
    }
    #howto_post {
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-wrap: wrap;
      #subtitle {
        width: 100%;
        color: #020202;
        font-size: 23px;
        margin-top: 70px;
        position: relative;
        span {
          width: 20px;
          height: 100%;
          position: absolute;
          background-color: #000462;
          border-radius: 2px;
        }
        p {
          margin: 0;
          width: 330px;
          text-align: center;
          border-bottom: 1px solid #040062;
        }
      }
      #howto_post_caption {
        color: #403f3f;
        margin: 30px 0px;
      }
      #howto_img {
        background-image: url("../../assets/img/howto_dream_post.jpg");
        background-size: $howto_img_width $howto_img_height;
        background-repeat: no-repeat;
        margin: 0;
        margin-top: 10px;
        width: $howto_img_width;
        height: $howto_img_height;
      }
      #howto_post_explain {
        color: #2f2f2f;
        width: 780px;
        margin: 30px 0px;
        ol li {
          margin: 7px 0px;
        }
      }
    }
  }
}
</style>